var React = require('react');

function Neptune (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.008 4L5.015 7.025l1.159 1.531L7.59 7.483c-.622 4.996-.356 8.138.965 10.197.722 1.126 1.78 1.856 2.975 2.251.928.307 1.94.436 3.031.479v2.718h-3.57v1.92h3.57v3.656h1.92v-3.657h3.57v-1.92h-3.57V20.41c1.091-.043 2.104-.172 3.032-.479 1.194-.395 2.252-1.125 2.975-2.251 1.295-2.018 1.58-5.07 1.005-9.896l1.333 1.038 1.18-1.515-3.953-3.077-3.017 4.026 1.537 1.152 1.013-1.354c.525 4.603.145 7.25-.715 8.59-.48.75-1.087 1.175-1.962 1.465-.662.219-1.478.334-2.428.378V10.03l1.14 1.135 1.355-1.36-3.555-3.544-3.477 3.624 1.385 1.329 1.232-1.284v8.559c-.948-.045-1.765-.16-2.427-.38-.876-.29-1.481-.714-1.963-1.464-.869-1.355-1.246-4.05-.696-8.744l.946 1.296 1.552-1.132L9.008 4z"}));
}

Neptune.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Neptune;

Neptune.default = Neptune;
